import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import ShareLink from 'chameleon/ui-stack/ui/base/share-link';

const ButtonWithIconShareLink = (props) => {
  const { children, notificationText, onCopy, text, timeout, tooltip } = props;

  return (
    <ShareLink
      text={text}
      timeout={timeout}
      onCopy={onCopy}
      notificationText={notificationText}
      tooltip={tooltip}
    >
      <ButtonWithIcon data-test-id="copy-link" isLink isNaked icon="copy_link">
        {children}
      </ButtonWithIcon>
    </ShareLink>
  );
};

ButtonWithIconShareLink.propTypes = {
  children: PropTypes.node.isRequired,
  notificationText: PropTypes.string,
  onCopy: PropTypes.func,
  text: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  tooltip: PropTypes.object,
};

ButtonWithIconShareLink.defaultProps = {
  notificationText: undefined,
  onCopy: null,
  timeout: undefined,
  tooltip: null,
};

export default ButtonWithIconShareLink;
